import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";

import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import ActionButtons from "./../../components/page/drive/ActionButtons/ActionButtons";
import TruckCounts from "./../../components/page/drive/TruckCounts/TruckCounts";
import Table from "./../../components/general/Table/Table";
import PaymentScheduleModal from "./../../components/page/drive/PaymentScheduleModal/PaymentScheduleModal";
import classes from './DrivePage.module.scss';
import Loading from "../../components/wrapper/Loading/Loading";
import DataTable from "../../components/general/DataTable/DataTable";
import EditIcon from '@mui/icons-material/Edit';
import { boxiPrimary } from "../../assets/style/colors";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class DrivePage extends Component {
  state = {
    trucksOnCampaign: 0,
    truckInventory: 0,
    vendorTableData: [],
    needsAttentionTableData: [],
    paymentScheduleModalShow: false,
    selectedTruckId: null,
    activeTab: 0,
    isLoading: false,
    isNeedsAttentionLoading: false,

    allVendorTrucksRows: [],
    allVendorTrucksColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 1, field: 'code', headerName: 'Vendor Code' },
      { flex: 1, field: 'name', headerName: 'Name' },
      { flex: 1, field: 'assigned_trucks', headerName: 'Trucks on Campaigns' },
      { flex: 1, field: 'available_trucks', headerName: 'Truck Inventory' },
      { flex: 1, field: 'pipeline', headerName: 'Pipeline' },
      { flex: 1, field: 'nickname', headerName: 'Nickname' },
      { flex: 1, field: 'city', headerName: 'City' },
      { flex: 1, field: 'moves_for', headerName: 'Freight Company' },
      { flex: 1, field: 'area_covered', headerName: 'Area Covered' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => this.props.history.push(`/dashboard/admin/drive/vendor/edit/${params.row.vendor_id}`)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        );
      } }
    ],
    vendorTrucksParams: {
      sortOrder: 'asc',
      sortBy: 'code',
      page: 0,
      pageSize: 10,
      search: null
    },
    isVendorTrucksLoading: false,
    totalVendorTrucks: 0
  };


  getVendorTrucks = (sortOrder, sortBy, page, pageSize, search) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      vendorTrucksParams: params,
      isVendorTrucksLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/vendor`, {params}).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        const rows = [];
        res.data.vendors.map((vendor, index) => {
          rows.push({
            id: (page * pageSize) + index + 1,
            vendor_id: vendor.vendor_id,
            name: vendor.name,
            code: vendor.code,
            assigned_trucks: vendor.assigned_trucks,
            available_trucks: vendor.available_trucks,
            pipeline: vendor.pipeline,
            nickname: vendor.nickname,
            city: vendor.city,
            moves_for: vendor.moves_for,
            area_covered: vendor.area_covered
          })
        });
        this.setState({
          allVendorTrucksRows: rows,
          isVendorTrucksLoading: false,
          totalVendorTrucks: res.data.rowCount
        })
      }
    })
  }

  getDriveTotals = () => {
    this.setState({
      isLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/vendor/driveTotals`).then((res) => {
      if (res.status === 200) {
        this.setState({
          trucksOnCampaign: res.data.trucksOnCampaign,
          truckInventory: res.data.truckInventory,
          isLoading: false
        })
      }
    })
  }

  vendorTableHeaders = ["id", "Vendor Code", "Vendor", "Trucks on Campaigns", "Truck Inventory", "Pipeline", "Nickname", "City", "Freight Company", "Area Covered"];
  vendorTableButtons = [
    {
      display: "View-Edit",
      onClickHandler: (index, id) => {
        this.props.history.push(`/dashboard/admin/drive/vendor/edit/${id}`);
      }
    }
  ];
  needsAttentionTableHeaders = ["id", "Vendor", "Truck Name", "Campaign", "Start Date"];
  needsAttentionTableButtons = [
    {
      display: "Add Payment Schedule",
      onClickHandler: (index, id) => {
        // open modal to add payment schedule
        this.setState({
          paymentScheduleModalShow: true,
          selectedTruckId: id
        });
      }
    }
  ];

  componentDidMount = async () => {
    this.getVendorTrucks('asc', 'code', 0, 10, null);
    this.getDriveTotals();

    this.setState({
      isNeedsAttentionLoading: true
    })
    let data = {
      ...(await this.loadNeedsAttention())
    };
    this.setState({
      isNeedsAttentionLoading: false
    })
    this.setState(data);
    // Add a resize event listener to the window object
    window.addEventListener('resize', this.handleResize);
  };

  loadVendors = async () => {
    try {
      let res = await trackPromise(axios.get(`${process.env.REACT_APP_API_HOST}/vendor`, { withCredentials: true }));
      if (res.status === 200) {
        let trucksOnCampaign = 0;
        let truckInventory = 0;
        let vendors = res.data.vendors.map((vendor) => {
          trucksOnCampaign += parseInt(vendor.assigned_trucks);
          truckInventory += parseInt(vendor.available_trucks);
          return [
            vendor.vendor_id,
            vendor.code,
            vendor.name,
            vendor.assigned_trucks,
            vendor.available_trucks,
            vendor.pipeline,
            vendor.nickname,
            vendor.city,
            vendor.moves_for,
            vendor.area_covered
          ];
        });
        return {
          trucksOnCampaign: trucksOnCampaign,
          truckInventory: truckInventory,
          vendorTableData: vendors
        };
      }
    } catch (err) {
      console.log(err);
    }
    return {};
  };

  loadNeedsAttention = async () => {
    try {
      let res = await trackPromise( axios.get(`${process.env.REACT_APP_API_HOST}/truck/assigned/payment_schedule/unassigned`, {
        withCredentials: true
      }));
      if (res.status === 200 && res.data.trucks) {
        let trucks = res.data.trucks.map((truck) => [
          truck.truck_id,
          truck.vendor_name,
          truck.truck_name,
          truck.campaign_name ? truck.campaign_name : "N/A",
          moment(truck.tracking_start).format("MM/DD/YYYY")
        ]);
        this.setState({
          needsAttentionTableData: trucks
        });
      }
    } catch (err) {
      console.log(err);
    }
    return {};
  };

  togglePaymentScheduleModal = () => {
    this.setState({
      paymentScheduleModalShow: !this.state.paymentScheduleModalShow
    });
  };

  addPaymentSchedule = async (startDate, endDate, campaignId, paymentAmount) => {
    // format data for request
    let paymentSchedule = {
      data: {campaign_id: campaignId, start_date: startDate, end_date: endDate, monthly_rate: paymentAmount}
    };

    try {
      let res = await axios.put(
        `${process.env.REACT_APP_API_HOST}/truck/${this.state.selectedTruckId}/payment_schedule`,
        paymentSchedule.data,
        config
      );
      // check if request was successful
      if (res.status === 200 && res.data.new_ps && res.data.new_ps[0].payment_schedule_id) {
        alert("Payment schedule was added");
        window.location.reload();
      }
    } catch (err) {
      console.log(err);
    }
  };

  selectTab = (index) => {
    this.setState({
      activeTab: index
    })
    setTimeout(() => {
      index === 1 && window.dispatchEvent(new Event('resize'));
    }, 1);
  }

  componentWillUnmount() {
    // Remove the resize event listener when the component is unmounted
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    // Force the table to redraw when the window is resized
    this.forceUpdate();
  }

  render() {
    return (
      <Fragment>
        {/* <Loading loading={this.state.isLoading} label="Loading Vendors..." /> */}
        <Helmet>
          <title>Boxi Admin | Drive</title>
        </Helmet>
        <div className={classes.titleContainer}>
          <Title>Drive</Title>
          <div className={classes.linksContainer}>
            <Link className={classes.linkTag} to="/dashboard/admin/drive/vendor/create">
              + New Vendor
            </Link>
          </div>
        </div>
        <Row className="mb-5">
          <Col xs="12" md={6}>
            <TruckCounts isLoading={this.state.isLoading} campaignTrucks={this.state.trucksOnCampaign} truckInventory={this.state.truckInventory} />
          </Col>
        </Row>

        <div className={classes.tabs}>
          <div onClick={() => this.selectTab(0)} className={this.state.activeTab === 0 ? classes.activeTab : classes.tab}>
            All Truck Vendors
          </div>
          <div onClick={() => this.selectTab(1)} className={this.state.activeTab === 1 ? classes.activeTab : classes.tab}>
            Needs Attention
          </div>
        </div>

        {/* Needs Attention Table */}
        <Row className={`mt-4 ${this.state.activeTab === 1 ? classes.activeTable : classes.inactiveTable}`}>
          <Col xs="12">
            <Table
              id="needs-attention-table"
              title="Needs Attention"
              buttons={this.needsAttentionTableButtons}
              headers={this.needsAttentionTableHeaders}
              data={this.state.needsAttentionTableData}
              maxHeight="400px"
            />
          </Col>
        </Row>

        {/* Vendor Table */}
        <Row className={`mt-4 ${this.state.activeTab === 0 ? classes.activeTable : classes.inactiveTable}`}>
          <Col xs="12">
            {/* <Table
              id="vendors-truck-table"
              title="All Truck Vendors"
              buttons={this.vendorTableButtons}
              headers={this.vendorTableHeaders}
              data={this.state.vendorTableData}
              colors={["#FC575E", "#F7B42C"]}
            /> */}
            <DataTable
              title="All Vendor Trucks"
              rows={this.state.allVendorTrucksRows}
              columns={this.state.allVendorTrucksColumns}
              fetchData={this.getVendorTrucks}
              params={this.state.vendorTrucksParams}
              isLoading={this.state.isVendorTrucksLoading}
              rowCount={this.state.totalVendorTrucks}
            />
          </Col>
        </Row>
        <PaymentScheduleModal
          show={this.state.paymentScheduleModalShow}
          toggleModal={this.togglePaymentScheduleModal}
          add={this.addPaymentSchedule}
        />
      </Fragment>
    );
  }
}

export default withRouter(DrivePage);
